import React from 'react';
import { Box, CircularProgress, Typography, Fade, Grow, Stack } from '@mui/material';

const MyLoader = ({ loading = true, message = 'Loading...' }) => {
  return (
      <Grow
        in={true}
        timeout={{ enter: 600, exit: 300 }}
        style={{ transformOrigin: "50% 0 0" }} // Center origin
        mountOnEnter
        unmountOnExit
      >
    <Fade in={loading}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1300,
        }}
      >
        <Stack
          direction="column"
          spacing={2}
          sx={{ alignItems: 'center' }}
        >
          <CircularProgress />
          <Box
            sx={(theme) => ({
              pt: 1,
              pb: 1,
              pl: 2,
              pr: 2,
              borderRadius: 4,
              display: 'flex',
              backdropFilter: 'blur(24px)',
              boxShadow: 'rgba(0, 0, 0, 0.05) 0px 4px 12px',
              bgcolor:
                theme.palette.mode === 'light'
                  ? 'rgba(248, 255, 252, 0.4)'
                  : 'rgba(0, 0, 0, 0.8)',
            })}
          >
            <Typography variant="h6" color="text.secondary">
              {message}
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Fade>
    </Grow>
  );
};

export default MyLoader;